import { createFileRoute } from '@tanstack/react-router';
import { lerBusca, OrcamentosListaPage } from '@/components/orcamentos-lista';

export const Route = createFileRoute('/_app/vender/orcamentos/')({
  validateSearch: (bruto: Record<string, unknown>) => lerBusca(bruto),
  component: ListaRota,
});

function ListaRota() {
  return <OrcamentosListaPage busca={Route.useSearch()} />;
}
